module.exports = __webpack_public_path__ + "static/media/foodie.02132a88.png";